// noinspection ES6UnusedImports
import * as bootstrap from 'bootstrap';
import type Swup from "swup";
import $ from 'jquery';

import Layouts from "@/modules/layouts";
import Plugins from "@/modules/plugins";
import Cookies from "@/modules/cookies";
import Designer from "@/modules/designer";
import {animateScrollTo} from "@/modules/utils";

window.jQuery = window.jquery = window.$ = $;

let viewsManager: Swup | null = null;

(function (window, _, $) {
    'use strict';

    window.__viewStory = {
        primary: '/',
        previous: '/',
        current: '/',
    }

    const App = {

        init: () => {
            window.__loaded = false;
            window.__scrollbars = {};
            window.__viewStory.primary = window.location.pathname;

            App.once();
            App.core();
            App.viewManager();
        },

        once: () => {
            Plugins.initSentry();
            Cookies.consent.init();
            Designer.initPreloader();
        },

        core: () => {
            Plugins.init();
            Designer.init();
            Layouts.init();
        },

        viewManager: () => {
            const swupViews = ['#root', '#mobile__menu', '#header__upgrade', '#footer__upgrade', '[data-async-configs]', '[data-wpml-lang]'];
            let viewsContainer = []
            for (const swupViewsKey in swupViews) {
                if ($(swupViews[swupViewsKey]).length) viewsContainer.push(swupViews[swupViewsKey])
            }

            // const __transitor = new SwupOverlayTheme({color: 'rgba(255,255,255,.5)', duration: 600, direction: 'to-right',})

            viewsManager = Designer.initViewManager({
                containers: viewsContainer,
                onContentReplace: () => {
                    Designer.removeListeners();
                },
                onContentLoaded: () => {
                    App.core();
                    $(window).trigger('app:loaded');
                },
                onAnimationEnd: () => {
                    if (window.AppScroll) {
                        if (window.AppScroll.animatedScroll >= 100) {
                            window.AppScroll.scrollTo(0, {
                                duration: 300,
                                immediate: true,
                            })
                        }
                    } else if (window.scrollY >= 100) {
                        animateScrollTo(document.body, 0, 300);
                    }
                },
                animationPlugin: undefined,
                debug: false
            })
        },
    }

    $(function () {
        App.init();
        if (viewsManager != null) window.Views = viewsManager;
        window.App = App;
    });
})(window, document, $);
